import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalSecurityService {
  public isDevToolsCurrentlyOpen = false;

  initSecurity(): void {}

  public evaluateDevTools(): boolean {
    return false;
  }

  public canProceed(): boolean {
    return true;
  }

  public triggerViolation(): void {}
}
